import { IconMap } from '@conexasaude/iconography/icons'
import { SerializedStyles } from '@emotion/react'

export type MenuItem = {
  id: number
  type: 'link' | 'button'
  onClick?: () => void
  path?: string
  label: string
  css?: SerializedStyles
  icon: IconMap
  show: boolean
  analyticsEvent?: string
  cy?: string
}

export type NavbarProps = {
  hideMenuOptions?: boolean
  showAvatar?: boolean
}

export enum NAVBAR_MODALS {
  SOS_MENTAL_HEALTH = 'SOS_MENTAL_HEALTH',
  SOS_ERROR_MENTAL_HEALTH = 'SOS_ERROR_MENTAL_HEALTH_NAVBAR',
  SOS_CONFIRM_PATIENT = 'SOS_CONFIRM_PATIENT',
  DEPENDENTS_MODAL = 'DEPENDENTS_MODAL_NAVBAR',
  MINOR_ACCESS_MODAL = 'GUARDIAN_ACCESS_REQUEST_MODAL_NAVBAR',
}
